import { CheckCircleOutline, EmailOutlined, TextFields } from "@material-ui/icons";
import { Switch, Typography, Button, Box, Modal, Dialog, DialogTitle, DialogContent, DialogContentText, TextField } from "@mui/material";
import QuestionViewModal from "modules/question-bank/questionViewmodal";
import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { apiPaths, getData, postData } from "../platform-components/api-integration-util";
import Grid from "../platform-components/grid/Grid";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import CloseIcon from '@mui/icons-material/Close';
import JoditEditor from 'jodit-react';
import { Margin } from "@mui/icons-material";
import { Toaster } from '../platform-components/Toaster';
import { toast } from 'react-toastify';

const style = {
  display: 'flex',
  flexDirection: 'column',
  m: '0px !important',
  width: 'fit-content'
};
const style1 = {
  display: 'flex',
  flexDirection: 'column',
  //width: 'fit-content',
  width: "100%",
  Margin: "0px !important"
};

const icon = {
  position: "absolute",
  top: " 6px",
  right: "11px",
  fontSize: "16px",
  cursor: "pointer"
}
const button = {
  marginTop: "10px",
  maxWidth: "120px",
  position: "absolute",
  right: "30px",
  bottom: "10px",
}



const Feedback = () => {
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewFeedback, setShowNewFeedback] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionIdList, setQuestionIdList] = useState([]);
  const [singleComment, setSingleComment] = useState()
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(null); // Define selectedQuestionEditable
  const [QBCount, setQBCount] = useState(0); // Define QBCount
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const [questionData, setQuestionData] = useState([]);
  const [studentEmail, setStudentEmail] = useState([])
  const [commentName, setCommentName] = useState();
  const [questionID, setQuestionID] = useState();
  const [open, setOpen] = useState(false);
  const [openReply, setOpenReply] = useState(false);
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const [contentError, setContentError] = useState(false)
  const [rowData, setRowData] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState({});
  //const [subject, setSubject] = useState()
  const handleOpen = (data) => {

    setSingleComment(data.value)
    setStudentEmail(data.data.studentEmail)
    setCommentName(data.data.name)
    setOpen(true)
  };
  const handleClose = () => {
    setOpen(false)
  };
  const handleCloseReply = () => {
    setOpenReply(false)
  }

  const getPlainText = (content) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const onSendMailClick = () => {
    const body = {
      htmlBody: content,
      studentEmail: studentEmail,
      subject: 'Resolution of Your Feedback on QID: '+ questionID,
      textBody: getPlainText(content)
    }
    postData(apiPaths.sendQuestionFeedbackMail, {
      data: body,
    }).then((res) => {
      const responseData = res?.result;
      setRowData(responseData);
      Toaster(toast.TYPE.SUCCESS, `${res.msg}`);
      setLoading(false);
      handleCloseReply();
    });
  }



  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const userDetails = getUserDetails();
      const statusQueryParam = showNewFeedback ? "COMPLETE" : "NEW";
      const queryParams = `?libTypeList=QBANK&libTypeList=TEST&status=${statusQueryParam}&tenantId=${userDetails.tenantId}&userEmail=${userDetails.email}`;
      const response = await getData(
        apiPaths.getFeedbackForQuestions + queryParams
      );
      setFeedbackData(response.result);

      // Extract unique question IDs from feedback data
      const uniqueQuestionIds = [...new Set(response.result.map(feedback => feedback.questionId))];

      setQuestionIdList(uniqueQuestionIds);
      setQBCount(uniqueQuestionIds.length);

    } catch (error) {
      console.error("Error fetching feedback:", error);
    } finally {
      setLoading(false);
    }
  }, [showNewFeedback]);

  useEffect(() => {
    fetchData();
  }, [fetchData, showNewFeedback]);

  const handleTickButtonClick = async (uniqueId, libType) => {
    try {
      const queryParams = new URLSearchParams({
        uniqueId,
        libType,
        newStatus: "COMPLETE", // Assuming you always want to set status as "COMPLETE"
      }).toString();

      const response = await postData(apiPaths.updateQuestionFeedbackStatus + "?" + queryParams, {
      });
      console.log("Feedback status updated:", response);
      // After updating the status, fetch the updated feedback data
      await fetchData();
    } catch (error) {
      console.error("Error updating feedback status:", error);
    }
  };

  const tickButtonRenderer = (params) => {
    const feedback = params.data;
    if (feedback.status === "NEW") {
      return (
        <div style={{display: 'flex'}}>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleTickButtonClick(feedback.uniqueId, feedback.libType)}
          >
            <CheckCircleOutline /> {/* Use the CheckIcon component */}
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => onReplyClick(params.data)}
          >
            <EmailOutlined /> {/* Use the CheckIcon component */}
          </div>
        </div>
      );
    }
    return null;
  };

  const handleQuestionClick = (questionId) => {
    const clickedIndex = questionIdList.indexOf(questionId);

    setSelectedQuestionIndex(clickedIndex);
    setSelectedQuestionId(questionId);

    // Fetch question data for the clicked question ID
    getData(apiPaths.questionbyid + `?id=${questionId}`).then((response) => {
      if (response.result) {
        setQuestionData(response.result);
      }
    });
  };



  const columnDefs = [
    { headerName: "Name", field: "name", tooltipField: "name" },
    { headerName: "Library Type", field: "libType", tooltipField: "libType" },
    {
      headerName: "Question ID",
      field: "questionId",
      tooltipField: "questionId",
      cellRendererFramework: (params) => (
        <div
          className="text-link"
          onClick={() => handleQuestionClick(params.value)}
          style={{ cursor: "pointer" }}
        >
          {params.value}
        </div>
      ),
    },
    // {
    //   headerName: "Question",
    //   field: "questionPlainText",
    //   width: 200,
    //   filter: true,
    //   tooltipField: "questionPlainText",
    // },
    {
      headerName: "Student Email",
      field: "studentEmail",
      tooltipField: "studentEmail",
    },
    {
      headerName: "Error Reported",
      field: "errorReported",
      tooltipField: "errorReported",
    },
    {
      headerName: "Comments",
      field: "comments",
      tooltipField: "comments",
      cellRendererFramework: (params) => (
        <Button onClick={() => { handleOpen(params) }}
          style={{ cursor: "pointer" }}>
          View
        </Button>

      ),
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      tooltipField: "createdDate",
    },
    { headerName: "Status", field: "status", tooltipField: "status" },
  ];

  const gridOptions = {
    columnDefs,
    rowData: feedbackData,
  };

  const handleToggleSwitch = () => {
    setShowNewFeedback(!showNewFeedback);
    setSelectedQuestionId(null);
    setSelectedQuestionIndex(-1);
    setQuestionData({});
  };

  const onReplyClick = (data) => {
    setSelectedFeedback(data);
    setStudentEmail(data.studentEmail);
    setCommentName(data.name);
    setQuestionID(data.questionId);
    setContent(`<p>Dear ${data.studentEmail},</p>
<p>Thank you for reaching out to us regarding your concern about the question in the Arise Medical Academy app. We appreciate your feedback, as it helps us improve the quality of our content.</p>
<p>Upon reviewing the question , we have <span style="background-color: rgb(255, 255, 0);">[corrected and verified]</span> the information accordingly. Kindly review the question for the updated Version.</p>
<p>We apologize for any confusion this may have caused and appreciate your patience. Please feel free to reach out if you have any further concerns or need additional clarification.</p>
<p>Thank you for being a valued user of Arise Medical Academy.</p>`)
    setOpenReply(true);
  }

  return (
    <>
      <div>
        <h2>Feedback</h2>
        <div className="toggle-button-container" style={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography>
            {showNewFeedback ? "Show Actioned Feedback" : "Show Completed Feedback"}
          </Typography>
          <Switch
            checked={showNewFeedback}
            onChange={handleToggleSwitch}
            size="small"
          />
        </div>
        {loading && <p>Loading...</p>}
        {!loading && feedbackData && feedbackData.length > 0 && <Grid
          gridOptions={{
            ...gridOptions,
            pagination: true,
            paginationPageSize: 10,
            columnDefs: [
              ...columnDefs,
              {
                headerName: "Action",
                cellRendererFramework: tickButtonRenderer,
              },
            ],
          }}
          parent="feedback"
        />}

        {selectedQuestionId && selectedQuestionIndex !== -1 && (
          <QuestionViewModal
            open={true}
            handleClose={() => {
              setSelectedQuestionId(null);
              setSelectedQuestionIndex(-1);
              setQuestionData({});
            }}
            selectedQuestionEditable={selectedQuestionEditable}
            isEditEnabled={true}
            prevQuestion={
              selectedQuestionIndex > 0
                ? questionIdList[selectedQuestionIndex - 1]
                : null
            }
            nxtQuestion={
              selectedQuestionIndex < questionIdList.length - 1
                ? questionIdList[selectedQuestionIndex + 1]
                : null
            }
            questionData={questionData}
            QBCount={QBCount}
            selectedQuestion={selectedQuestionId}
            setId={(e) => {
              setSelectedQuestionId(e);
              setSelectedQuestionIndex(questionIdList.indexOf(e));
              // Fetch question data for the clicked question ID
              getData(apiPaths.questionbyid + `?id=${e}`).then((response) => {
                if (response.result) {
                  setQuestionData(response.result);
                }
              });
            }}
          />
        )}
      </div>

      <Dialog
        open={open}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ borderBottom: "1px solid gainsboro" }}>Comment Details</DialogTitle>
        <DialogContent>
          <Box sx={style}>
            <CloseIcon sx={icon} onClick={handleClose} />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Typography><span style={{ fontWeight: "bold" }}>Email:</span> <span style={{ color: "#3e4095", fontWeight: "bold" }}>{studentEmail}</span></Typography>
              <Typography><span style={{ fontWeight: "bold" }}>Name:</span> {commentName}</Typography>
              <Typography><span style={{ fontWeight: "bold" }}>Comment:</span> {singleComment ? singleComment : "No Comments"}</Typography>
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth={true}
        open={openReply}
        onClose={handleCloseReply}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="lg"
        sx={{ minHeight: "420px !important" }}
      >
        <DialogTitle style={{ border: "1px solid #e7e0e0", backgroundColor: "#e7e0e0" }}>Reply Message</DialogTitle>
        <DialogContent>
          <Box sx={style1}>
            <CloseIcon sx={icon} onClick={handleCloseReply} />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Typography sx={{ borderBottom: "1px solid #e7e0e0", padding: "10px 10px 10px 0px" }}><span style={{ fontWeight: "bold" }}>To: </span><span style={{ color: "#3e4095" }}>{studentEmail}</span></Typography>
              <Typography sx={{ borderBottom: "1px solid #e7e0e0", padding: "10px 10px 10px 0px" }}><span style={{ fontWeight: "bold" }}>Subject: </span><span>Resolution of Your Feedback on QID: <span style={{ color: "#3e4095" }}>{questionID}</span></span></Typography>
            </Typography>

            {/* <Typography variant="h6"></Typography>
            <TextFields
              fullWidth
              multiline
              disabled
              value={singleComment}
              variant="outlined"
              sx={{ mb: 2 }}
            /> */}
            <JoditEditor
              ref={editor}
              value={content}
              tabIndex={1} // tabIndex of textarea
              onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
              onChange={(newContent) => { setContentError(false); setContent(newContent) }}
            />
            <div style={{ display: "flex", justifyContent: "right" }}>
              <button className="btn-common" style={{ marginTop: "10px", maxWidth: "120px" }} onClick={onSendMailClick}>Send</button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Feedback;
